import info from "./status";
import { meetingService } from "../services/meeting";
import { ck, URLS } from "fire-wind-water";

class GetUrl {
  static modules: { [label: string]: string | any }[] = [];
  tenantId = URLS.getURL("tenantId");
  instanceId = URLS.getURL("instanceId");
  webinarId = URLS.getURL("webinarId");
  cookie: string;
  isLogin: boolean;
  returnUrl: string;
  loginUrl: string;
  isWeChatBrowser: boolean;
  registrationForm: any;
  device: boolean;
  device1: string;
  customFormId: string;
  customForm: any;
  htmlArray: any;
  tc: string;
  isMobile: boolean;
  info: any = {};
  webinarInfo: any = {};
  userInfo: any = {};

  constructor() {
    this.cookie = "";
    this.isLogin = false;
    this.returnUrl = window.location.href;
    this.loginUrl = "";
    this.isWeChatBrowser =
      navigator.userAgent.toLowerCase().indexOf("micromessenger") > -1;
    this.registrationForm = {};
    this.device = !!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i);
    this.device1 = "";
    this.customFormId = URLS.getURL("customFormId");
    this.customForm = null;
    this.htmlArray = null;
    this.tc = URLS.getURL("tc");
    this.isMobile = !!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i);
  }

  async goToLogin(webinarinfo, user) {
    console.log("获取 登录 url", webinarinfo, user);
    const webinar = webinarinfo;
    return meetingService
      .getRegistrationForm({
        tenantId: webinar.tenantId,
        memberFormId: webinar.registrationFormId,
      })
      .then((data) => {
        this.registrationForm = data.content;
        this.device1 = this.device ? "wap" : "pc";
        this.loginUrl = this.registrationForm.originUrl[this.device1];
        this.loginUrl += this.loginUrl.indexOf("?") > -1 ? "&" : "?";
        if (URLS.getURL("markCode")) {
          this.loginUrl += "markCode=" + URLS.getURL("markCode") + "&";
        }
        if (URLS.getURL("memberFormId")) {
          this.loginUrl += "memberFormId=" + webinar.registrationFormId + "&";
        }
        if (this.isWeChatBrowser) {
          //是在微信中打开
          const weChatId = webinar.weChatId;
          if (weChatId) {
            this.loginUrl += "weChatId=" + weChatId + "&";
          }
        }
        console.log("loginUrl1", this.loginUrl);
        (window as any).$sk.goto(this.loginUrl, true).subscribe((res) => {
          webinar.loginUrl = res;
          info.meeting.mettingChange.next(webinar);
          console.log("loginUrl2", res);
        });
      });
  }
  //替换注册链接里的线上会渠道参数
  delParamsByCustomFormUrl(url) {
    ck.json = true;
    const channelList = ck.cookie();
    const channeParams = [];
    for (const val in channelList) {
      // eslint-disable-next-line no-prototype-builtins
      if (channelList.hasOwnProperty(val) && val.indexOf("channel_") !== -1) {
        channeParams.push(val.replace("channel_", ""));
      }
    }
    const pageSearchArr = url.split("&");
    let pageParams = "";
    for (let i = 0; i < pageSearchArr.length; i++) {
      const d = pageSearchArr[i].split("=");
      if (
        (d[1] !== "" &&
          d[1] !== null &&
          d[1] !== undefined &&
          channeParams.indexOf(d[0]) === -1) ||
        d[1] === "markCode" ||
        d[1] === "marketingTaskId"
      ) {
        pageParams = pageParams + "&" + d[0] + "=" + d[1];
      }
    }
    url = pageParams.slice(1);
    return url;
  }
  async goToSignUp(webinar) {
    if (webinar.isOpen && !webinar.isClosed) {
      (window as any).$sk
        .goto(window.location.href.replace("/meetingInfo", "/meeting"), true)
        .subscribe((res) => {
          this.returnUrl = res;
        });
    } else {
      (window as any).$sk.goto(window.location.href, true).subscribe((res) => {
        this.returnUrl = res;
      });
    }
    let configId = "";
    const type = this.device ? "mobile" : "pc";
    const queryConfigId = URLS.getURL("configId");
    let pageSearch = window.location.search + "&isWebinar=1";
    const globalUserId = ck.cookie("globalUserId"); //
    return await meetingService
      .getCustomForm({
        tenantId: webinar.tenantId,
        customFormId: webinar.customFormId,
        globalUserId: globalUserId,
        __module__: 2,
        __objId__: webinar.id,
      })
      .then((data) => {
        this.customForm = data.content;
        this.htmlArray = this.customForm.template[type].html;
        configId = this.customForm.template[type].configId;
        if (configId !== queryConfigId) {
          pageSearch = pageSearch.replace(
            "configId=" + queryConfigId,
            "configId=" + configId
          );
        }
        if (!queryConfigId) {
          pageSearch += "&configId=" + configId;
        }
        //pageSearch处理，表单的url上直接拼接线上会的参数，如果加渠道参数时需要去除
        pageSearch = this.delParamsByCustomFormUrl(pageSearch);
        //做兼容新旧表单模板处理1
        console.log("做兼容新旧表单模板处理");
        if (this.customForm.templateVersion == 1) {
          let signUpHtmlIndexNew = 0;
          const toTitleNew = webinar.needLogin ? "_index" : "_verify";
          for (let j = 0, m = this.htmlArray.length; j < m; j++) {
            if (this.htmlArray[j].usePage.indexOf(toTitleNew) > 0) {
              signUpHtmlIndexNew = j;
              break;
            }
          }
          (window as any).$sk
            .goto(
              this.customForm.template[type].formalUrl +
                pageSearch +
                "&returnUrl=" +
                encodeURIComponent(this.returnUrl) +
                this.htmlArray[signUpHtmlIndexNew]["formalUrlOriginal"],
              true
            )
            .subscribe((url) => {
              webinar.goToSignUpUrl = url;
            });
          console.log("goToSignUpUrl :", webinar);
          info.meeting.mettingChange.next(webinar);
        } else {
          let signUpHtmlIndex = 0;
          const toTitle = webinar.needLogin ? "表单页" : "身份验证页面";
          for (let i = 0, max = this.htmlArray.length; i < max; i++) {
            if (this.htmlArray[i].title == toTitle) {
              signUpHtmlIndex = i;
              break;
            }
          }
          (window as any).$sk
            .goto(
              this.htmlArray[signUpHtmlIndex]["formalUrl"] +
                pageSearch +
                "&returnUrl=" +
                encodeURIComponent(this.returnUrl),
              true
            )
            .subscribe((url) => {
              webinar.goToSignUpUrl = url;
            });
          console.log("goToSignUpUrl :", webinar);
          info.meeting.mettingChange.next(webinar);
        }
      });
  }

  //验证是否报名
  silentSignUp(webinar, user, callback) {
    meetingService
      .checkRegistration({
        customFormId: this.customFormId,
        cookieId: ck.cookie("globalUserId"),
        instanceId: webinar.instanceId,
        sess: user.cookie ? user.cookie.session : "",
        openId: user.openId || "",
        includeFormData: 1,
        tenantId: webinar.tenantId,
      })
      .then((data) => {
        const params = {
          webinarId: webinar.id,
          moduleId: 2,
          tenantId: webinar.tenantId,
          formId: webinar.isSilent ? this.customFormId : 0,
          channel: this.tc || "",
          globalUserId: user.globalUserId,
          weChatId: webinar.weChatId || "",
          openId: webinar.unLimit ? "" : user.openId || "",
          sess: webinar.unLimit ? "" : user.cookie ? user.cookie.session : "",
          isPreview: "0",
          signUpSource: this.device ? "WAP" : "PC",
          isUnLimit: webinar.unLimit ? 1 : 0, //无限制观看静默报名 1 是 0 否
          // markCode 与 marketingSess 为用于统计的埋点相关参数
          markCode: URLS.getURL("markCode") || "",
          markType: URLS.getURL("markType") || "",
          marketingSess: ck.cookie("marketingSess") || "",
          formData: null,
        };
        if (data && data.content.formData && data.content.formData.length > 0) {
          params.formData = data.content.formData;
        }
        meetingService.silentSignUp(params).then((data) => {
          callback(data);
        });
      });
  }
}

export { GetUrl };
